module.exports = __webpack_public_path__ + "static/img/icon slt img (3).ff2d9630.svg";